<div class="cg-dialog">
  <button
    cignaButton="link inline no-underline"
    class="cg-dialog__close"
    (click)="onClose()"
  >
    Close
    <cigna-icon class="cml-close-icon" type="close-thin"></cigna-icon>
  </button>

  <h3 class="cg-dialog__header">
    {{ data.user.firstName }} {{ data.user.lastName }}
  </h3>

  <ng-container *ngIf="(viewAccessView$ | async) === 'loading'">
    <div class="cg-media">
      <div class="cg-media__img">
        <div class="cg-spinner cg-spinner-small"></div>
      </div>
      <div class="cg-media__bd cg-margin-top-xs cg-margin-left-sm">
        Loading access information for this user
      </div>
    </div>

    <div class="cg-button-group cg-margin-top-lg">
      <button cignaButton="primary" (click)="onClose()">Close</button>
    </div>
  </ng-container>

  <ng-container *ngIf="(viewAccessView$ | async) === 'error'">
    <div class="cg-error-msg cg-margin-bottom-lg">
      <cigna-icon type="exclamation-circle"></cigna-icon>
      <span data-spa-service-error>Error loading access for this user</span>
    </div>
    <div class="cg-button-group cg-margin-top-lg">
      <button cignaButton="primary" (click)="onClose()">Close</button>
    </div>
  </ng-container>

  <ng-container *ngIf="(viewAccessView$ | async) === 'edit'">
    <mat-dialog-content>
      <div class="cg-multicolumn-list cg-multi-column-list-lg-2">
        <ng-container *ngFor="let tin of (viewingUser$ | async)?.tins">
          <div
            *ngIf="tin.status !== 'awaiting approval'"
            class="cg-multicolumn-list__item cg-margin-bottom-lg"
          >
            <h4 class="cg-margin-top-none cg-margin-bottom-xs">
              {{ tin.tin }}
              <ng-container *ngIf="tin.name !== '' && tin.name !== ' '"
                >({{ tin.name }})</ng-container
              >
            </h4>
            <ul class="cg-bullet-list">
              <li
                *ngIf="tin.entitlements && tin.entitlements.length === 0"
                class="cg-bullet-list__item cg-bullet-list__item--none"
              >
                Basic information (settings & preferences and resources)
              </li>
              <li
                *ngFor="let entitlement of tin.entitlements"
                class="cg-bullet-list__item cg-bullet-list__item--none"
              >
                {{ entitlement.description }}
                <ul
                  *ngIf="
                    entitlement.functions && entitlement.functions.length > 0
                  "
                >
                  <li *ngFor="let function of entitlement.functions">
                    {{ function.name }}
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </ng-container>
      </div>
    </mat-dialog-content>
    <div class="cg-button-group cg-margin-top-lg">
      <button
        *ngIf="data.showEdit"
        data-test="cg-edit-btn"
        cignaButton="primary"
        (click)="onEdit()"
        [cignaTrackClicks]="[
          'trackEventOther',
          'Edit this user',
          'ac-WC019-View Edit',
          {
            eVar101: 'Manage User Access:Edit User',
            events: 'event443'
          }
        ]"
      >
        Edit this user
      </button>
    </div>
  </ng-container>
</div>
